export type WebRuntimeCapabilities = {
  appleMobile: boolean;
  standalone: boolean;
  microphone: boolean;
  webMidi: boolean;
  fileShare: boolean;
};

type CapabilityEnvironment = {
  userAgent: string;
  maxTouchPoints: number;
  standalone?: boolean;
  displayModeStandalone?: boolean;
  mediaDevices?: boolean;
  requestMidi?: boolean;
  share?: boolean;
  canShare?: boolean;
};

export function capabilitiesFromEnvironment(environment: CapabilityEnvironment): WebRuntimeCapabilities {
  const appleMobile = /iPhone|iPad|iPod/i.test(environment.userAgent)
    || (/Macintosh/i.test(environment.userAgent) && environment.maxTouchPoints > 1);
  return {
    appleMobile,
    standalone: environment.standalone === true || environment.displayModeStandalone === true,
    microphone: environment.mediaDevices === true,
    webMidi: environment.requestMidi === true,
    fileShare: environment.share === true && environment.canShare === true,
  };
}

export function detectWebRuntimeCapabilities(): WebRuntimeCapabilities {
  const standaloneNavigator = navigator as Navigator & { standalone?: boolean; requestMIDIAccess?: unknown };
  return capabilitiesFromEnvironment({
    userAgent: navigator.userAgent,
    maxTouchPoints: navigator.maxTouchPoints,
    standalone: standaloneNavigator.standalone,
    displayModeStandalone: window.matchMedia?.("(display-mode: standalone)").matches,
    mediaDevices: typeof navigator.mediaDevices?.getUserMedia === "function",
    requestMidi: typeof standaloneNavigator.requestMIDIAccess === "function",
    share: typeof navigator.share === "function",
    canShare: typeof navigator.canShare === "function",
  });
}

export function webMidiUnavailableMessage(capabilities: Pick<WebRuntimeCapabilities, "appleMobile" | "webMidi">): string {
  if (capabilities.webMidi) return "MIDIキーボードは未接続";
  if (capabilities.appleMobile) return "外部MIDIキーボード接続はこのWeb版では利用できません。将来のiPhoneネイティブ版で対応予定です";
  return "このブラウザはWeb MIDI入力に未対応です";
}
